export default __webpack_public_path__ + "img/48bd4acedce3468d1a90c640ed05525d.svg";